import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { RxCross1 } from "react-icons/rx";
import { Formik } from "formik";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import { HttpService } from "../../../service/HttpService";
import { toast } from "react-toastify";
import "../../Plant/View/View.scss";
import "../../../pages/Plant/PlantListAdd/Plant.scss";
import { IoMdAdd } from "react-icons/io";
import DeleteModal from "../../Model/DeleteModal";
import CircularProgress from "@mui/material/CircularProgress";
import { FormControl, Select } from "@mui/material";

function AssignSchedule({
  open,
  handleClose,
  schedule_task_id,
  fetchSchedule,
}) {
  const [cultivars, setCultivars] = useState([]);

  // 🔥 CHANGE: instead of single matricIds array, use map per row index
  const [matricIdsMap, setMatricIdsMap] = useState({});

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [loadingMatricIds, setLoadingMatricIds] = useState(false);
  const [existingAssignments, setExistingAssignments] = useState([]);

  const fetchCultivars = async () => {
    try {
      const httpService = new HttpService();
      const res = await httpService.get("plant/get_plant");
      setCultivars(res?.data?.data || []);
    } catch (e) {
      setCultivars([]);
    }
  };

  const fetchMotherTasks = async () => {
    try {
      const httpService = new HttpService();
      const res = await httpService.get(
        `motherplant/mother_task/${schedule_task_id}`
      );
      setExistingAssignments(res?.data || []);
    } catch (e) {
      setExistingAssignments([]);
    }
  };

  useEffect(() => {
    fetchMotherTasks();
    fetchCultivars();
  }, []);

  useEffect(() => {
    if (existingAssignments.length > 0) {
      existingAssignments.forEach((item, index) => {
        if (item.plant_id) {
          fetchMatricIds(item.plant_id, index, () => {}, {
            items: existingAssignments,
          });
        }
      });
    }
  }, [existingAssignments]);

  // 🔥 CHANGE: store matricIds per row index
  const fetchMatricIds = async (cultivarId, index, setFieldValue, values) => {
    if (!cultivarId) return;
    setLoadingMatricIds(true);
    try {
      const httpService = new HttpService();
      const res = await httpService.get(
        `motherplant/get_plant_mother/${cultivarId}`
      );
      setMatricIdsMap((prev) => ({
        ...prev,
        [index]: res?.data || [],
      }));
      if (setFieldValue && values) {
        setFieldValue(`items.${index}.matric_id`, "");
      }
    } catch (e) {
      setMatricIdsMap((prev) => ({
        ...prev,
        [index]: [],
      }));
    } finally {
      setLoadingMatricIds(false);
    }
  };

  const handleDeleteItem = (index, values, setFieldValue) => {
    if (values.items.length > 1) {
      const updatedItems = values.items.filter((_, idx) => idx !== index);
      setFieldValue("items", updatedItems);
    } else {
      toast.error("At least one MATRIC ID is required", {
        position: "top-right",
      });
    }
  };

  return (
    <>
      <Modal className="plant-modal" open={open} onClose={handleClose}>
        <Formik
          enableReinitialize
          initialValues={{
            items:
              existingAssignments.length > 0
                ? existingAssignments.map((item) => ({
                    id: item.id,
                    cultivar: item.plant_id || "",
                    matric_id: item.mother_plant_id || "",
                  }))
                : [
                    {
                      cultivar: "",
                      matric_id: "",
                    },
                  ],
          }}
          validationSchema={Yup.object().shape({
            items: Yup.array()
              .of(
                Yup.object().shape({
                  cultivar: Yup.string().required("Please Select Cultivar"),
                  matric_id: Yup.string().required("Please Enter MATRIC ID"),
                })
              )
              .min(1, "Please add at least one row"),
          })}
          onSubmit={async (values, { setSubmitting, validateForm }) => {
            const errors = await validateForm(values);
            if (Object.keys(errors).length > 0) {
              const firstKey = Object.keys(errors)[0];
              const firstError =
                typeof errors[firstKey] === "string"
                  ? errors[firstKey]
                  : "Please fill all required fields.";
              toast.error(firstError, { position: "top-right" });
              setSubmitting(false);
              return;
            }
            const httpService = new HttpService();
            try {
              await httpService.post(`motherplant/task/${schedule_task_id}`, {
                assignments: values.items.map((item) => ({
                  id: item.id,
                  plant_id: item.cultivar,
                  mother_plant_id: item.matric_id,
                })),
              });
              toast.success("Mother Plant Assigned Successfully", {
                position: "top-right",
              });
              fetchSchedule && fetchSchedule();
              handleClose();
            } catch (error) {
              toast.error(
                error?.response?.data?.error ||
                  error.message ||
                  "Something went wrong.",
                { position: "top-right" }
              );
            }
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="modal_block">
                <div className="modal_header">
                  <div className="modal_title_wrapper">
                    <h2 className="modal_title">Assign Mother Plant</h2>
                  </div>
                  <div className="cancel-btn-wrap">
                    <RxCross1
                      onClick={handleClose}
                      style={{ cursor: "pointer", fontSize: "16px" }}
                    />
                  </div>
                </div>
                <div className="modal_content">
                  <div className="row">
                    <div className="col-md-12">
                      {values.items?.map((item, index) => (
                        <div
                          key={`row-${index}`}
                          className="row justify-content-between"
                          style={{ alignItems: "center", marginBottom: 20 }}
                        >
                          {/* Cultivar Select */}
                          <div className="col-md-5">
                            <div className="form_field_wrapper m-0">
                              <label>
                                Cultivator
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <div className="fieldwithradio">
                                <FormControl
                                  key={`cultivar-${index}`}
                                  fullWidth
                                >
                                  <Select
                                    id={`items.${index}.cultivar`}
                                    name={`items.${index}.cultivar`}
                                    value={values.items[index].cultivar}
                                    onChange={(e) => {
                                      handleChange(e);
                                      fetchMatricIds(
                                        e.target.value,
                                        index,
                                        setFieldValue,
                                        values
                                      );
                                    }}
                                    onBlur={handleBlur}
                                    displayEmpty
                                    renderValue={(selected) => {
                                      if (!selected) {
                                        return <span>Select Cultivator</span>;
                                      }
                                      const selectedCultivar = cultivars.find(
                                        (c) => c.id === selected
                                      );
                                      return selectedCultivar
                                        ? selectedCultivar.name
                                        : "";
                                    }}
                                    className="w-100"
                                  >
                                    <MenuItem value="">
                                      Select Cultivator
                                    </MenuItem>
                                    {cultivars.map((cultivar) => (
                                      <MenuItem
                                        key={cultivar.id}
                                        value={cultivar.id}
                                      >
                                        {cultivar.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                              {touched.items &&
                              touched.items[index] &&
                              errors.items &&
                              errors.items[index] &&
                              errors.items[index].cultivar ? (
                                <div style={{ color: "red" }}>
                                  {errors.items[index].cultivar}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          {/* Matric ID Select */}
                          <div className="col-md-5">
                            <div className="form_field_wrapper m-0">
                              <label>
                                METRC ID
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <div className="fieldwithradio">
                                <FormControl
                                  key={`matric-${index}`}
                                  fullWidth
                                  disabled={loadingMatricIds}
                                >
                                  <Select
                                    id={`items.${index}.matric_id`}
                                    name={`items.${index}.matric_id`}
                                    value={values.items[index].matric_id || ""}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    displayEmpty
                                    renderValue={(selected) => {
                                      if (!selected) {
                                        return <span>Select MATRIC ID</span>;
                                      }
                                      const currentMatric = matricIdsMap[
                                        index
                                      ]?.find((obj) => obj.id === selected);
                                      return currentMatric
                                        ? currentMatric.matric_id
                                        : selected;
                                    }}
                                    className="w-100"
                                    endAdornment={
                                      loadingMatricIds ? (
                                        <CircularProgress size={20} />
                                      ) : null
                                    }
                                  >
                                    <MenuItem value="">
                                      Select MATRIC ID
                                    </MenuItem>
                                    {(matricIdsMap[index] || []).map(
                                      (matric) => (
                                        <MenuItem
                                          key={matric.id}
                                          value={matric.id}
                                        >
                                          {matric.matric_id}
                                        </MenuItem>
                                      )
                                    )}
                                  </Select>
                                </FormControl>
                              </div>
                              {touched.items &&
                              touched.items[index] &&
                              errors.items &&
                              errors.items[index] &&
                              errors.items[index].matric_id ? (
                                <div style={{ color: "red" }}>
                                  {errors.items[index].matric_id}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          {/* Delete Button */}
                          <div
                            className="col-md-1 p-0 mt-3"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            <RxCross1
                              onClick={() =>
                                handleDeleteItem(index, values, setFieldValue)
                              }
                              style={{
                                color: "red",
                                cursor: "pointer",
                                fontSize: "16px",
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Add Button */}
                  <div
                    className="float-right"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                      marginTop: "15px",
                    }}
                  >
                    <button
                      type="button"
                      onClick={() =>
                        setFieldValue("items", [
                          ...values.items,
                          { cultivar: "", matric_id: "" },
                        ])
                      }
                      className="btn btn-border flex"
                      style={{
                        display: "flex",
                        padding: "6px 12px",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                        borderRadius: "4px",
                        border: "1px solid #C0C0C0",
                      }}
                    >
                      <IoMdAdd
                        className="text-sm"
                        style={{
                          width: "20",
                          height: "20px",
                        }}
                      />
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "20px",
                          letterSpacing: "0em",
                        }}
                      >
                        Add
                      </span>
                    </button>
                  </div>
                </div>

                {/* Footer */}
                <div className="modal_footer">
                  <button
                    onClick={handleClose}
                    className="btn btn-border"
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </Modal>
      <DeleteModal
        open={openDeleteModal}
        HandleClose={() => setOpenDeleteModal(false)}
        HandleDelete={() => {
          setOpenDeleteModal(false);
        }}
      />
    </>
  );
}

export default AssignSchedule;
